<div class="row">
  <div class="col-sm-12">
    <h5 [innerHTML]="description"></h5>
  </div>
  <div class="col-sm-12 myIframe" *ngIf="pdfViewerUrl">
    <iframe [src]="pdfViewerUrl"
            type="application/pdf"></iframe>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <span class="k-icon k-i-file-pdf"></span> <a href="javascript:void(0)" (click)="openDocument(pdfUrl)">{{pdfLinkLbl}}</a>
  </div>
</div>
